
import Vue from "vue";
import ShowSpinners from "@/common/components/ShowSpinners.vue";

export default Vue.extend({
  name: "McaPreviewOnlineReportPDF",
  components: { ShowSpinners },
  props: {
    pdfUrl: String,
  },
  methods: {
    downloadPDF() {
      window.open(this.pdfUrl, "_blank");
    },
  },
});
